<template>
    <v-select v-model="autotuner" :items="autotuners" item-value="autotuner_id" item-text="name" :label="label|translate" :clearable="clearable">
    </v-select>
</template>

<script>
  import {getAutotuner} from "../helper";

  export default {
    name: 'AutotunerSelector',
    props: {
      value: Number,
        label: {type: String, default: "Autotuner"},
        clearable: {type: Boolean, default: true},
    },
    watch: {
      value () {
        if(this.autotuner!==this.value){
          this.autotuner = this.value
        }
      },
      autotuner (newValue) {
        this.$emit('input', newValue)
      },
    },
    async beforeMount () {
        let df = await getAutotuner({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.autotuners = df['result']
    },
      mounted(){
          if (this.value) {
              this.autotuner = this.value
          }
      },
    data () {
      return {
        autotuner: null,
        autotuners:[]
      }
    },
  }
</script>

<style scoped>

</style>
